import { Box } from "@mui/material";
import { ComponentColors } from "./types";

interface OnboardingPreviewProps {
  selectedPalette: ComponentColors["onboarding"];
}

const OnboardingPreview = ({ selectedPalette }: OnboardingPreviewProps) => {
  if (!selectedPalette) return null;

  return (
    <Box
      sx={{
        backgroundColor: selectedPalette.background,
        color: selectedPalette.foreground,
        padding: 3,
        borderRadius: 2,
        textAlign: "center",
        minWidth: 200,
        minHeight: 80,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <span style={{ color: selectedPalette.foreground, fontSize: "1.1rem" }}>
        Onboarding
      </span>
    </Box>
  );
};

export default OnboardingPreview;
